/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { TipoPraticaCloneForm } from '../model/models';
import { TipoPraticaCloneResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CloneTipoPraticaRequestParams {
    id: string;
    tipoPraticaCloneForm: TipoPraticaCloneForm;
}


export interface TipoPraticaCloneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Clona un TipoPratica esistente (SUPERADMIN)
     * Crea un nuovo TipoPratica clonando selettivamente il root e i satelliti del bando origine indicato dal path. Il payload richiede &#x60;codice&#x60; e &#x60;descrizione&#x60; obbligatori; &#x60;comune_id_destinazione&#x60; opzionale (null&#x3D;same-comune, UUID&#x3D;cross-comune); &#x60;include&#x60; opzionale con 7 toggle livello-1 (default: tutti true tranne &#x60;comunicazioni&#x3D;false&#x60;). Lo stato del nuovo TipoPratica e\&#39; sempre IN_ATTESA (anche se origine era PUBBLICATO). Gli operatori non sono mai clonati. Cross-comune azzera URL, scalari finanziari e contributi assegnazione. Vedi &#x60;openspec/changes/add-tipo-pratica-clone/&#x60; per le decisioni complete.  Risposte: - 201: &#x60;TipoPraticaCloneResponseDTO&#x60; con &#x60;tipo_pratica&#x60; (stesso shape di GET .../{id}) e &#x60;clone_summary&#x60;. - 400: payload invalido (codice/descrizione blank, comune_id_destinazione UUID inesistente). - 403: caller non SUPERADMIN. - 404: TipoPratica origine non trovato. - 409: codice gia\&#39; usato nel comune destinazione. - 422: &#x60;include.template_form_cittadino&#x3D;true&#x60; con &#x60;include.attributi_e_valori&#x3D;false&#x60;.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id}/clone
* @param requestParameters
     */
    cloneTipoPratica(requestParameters: CloneTipoPraticaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaCloneResponseDTO>;

}
